import { render } from "./Businesses.vue?vue&type=template&id=7fb390c5"
import script from "./Businesses.vue?vue&type=script&lang=js"
export * from "./Businesses.vue?vue&type=script&lang=js"
script.render = render

export default script